// src/App.js

import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import About from "./pages/About";
import Approach from "./pages/Approach";
import Testimonials from "./pages/Testimonials";
import Contact from "./pages/Contact";
// import UnderMaintenance from "./pages/UnderMaintenance";
import styles from "./styles/App.module.css";

function App() {
  return (
    <div className={styles.appContainer}>
      <Router>
        <Header />
        <Switch>
          <Route exact path="/" component={Home} />
          <Route path="/about" component={About} />
          <Route path="/approach" component={Approach} />
          <Route path="/testimonials" component={Testimonials} />
          <Route path="/contact" component={Contact} />
          {/* <Route path="/" component={UnderMaintenance} /> */}
        </Switch>
        <Footer />
      </Router>
    </div>
  );
}

export default App;
